import { defineComponent as _defineComponent } from 'vue'
import QuickStatisticsComponent from "@/components/quick-statistics-component.vue";
import CalendarComponent from "@/components/calendar-component.vue";
import TodaysScheduleComponent from "@/components/todays-schedule-component.vue";
import NoticeBoardDisplayComponent from "@/components/notice-board-display.vue";
import DashboardItemsSummary from "@/components/dashboard-items-summary.vue";
import BrowserNotSupportedWarningDialog from "@/components/dialogs/browser-not-supported-warning-dialog.vue";
import { isBrowserSupported } from "@/helpers/isBrowserSupported";
import { addMonths } from "date-fns";

import store from "@/store";

import { onMounted, ref, Ref } from "vue";
import useHttpRequest from "@/composables/use-http-request";
import UpcomingLecture from "@/interfaces/upcomingLecture.interface";


export default /*#__PURE__*/_defineComponent({
  __name: 'home',
  setup(__props) {

const loading = ref(false);
const isMonthCalendarLoading = ref(false);
const browserNotSupportedWarningDialogVisible = ref(false);

const dateToday = ref("");
const calendarMonth: Ref<number | undefined> = ref();
const calendarYear: Ref<number | undefined> = ref();
const assignedModules = ref(0);
const pendingResources = ref(0);
const totalClassesToday = ref(0);

const upcomingLectures = ref<UpcomingLecture[]>([]);
const notices: Ref<{ title: string; message: string }[]> = ref([]);
const eventDays = ref<number[]>([]);

const checkIfBrowserIsSupported = () => {
  if (!isBrowserSupported()) {
    browserNotSupportedWarningDialogVisible.value = true;
  }
};

const fetchLecturerDashboardHome = async () => {
  const request = await useHttpRequest<{
    success: boolean;
    message: string;
    date_today: string;
    assigned_intakes_modules: number;
    total_classes_today: number;
    pending_resources: number;
    notices: { title: string; message: string }[];
    days: number[];
    upcoming_lectures: UpcomingLecture[];
  }>({
    method: "GET",
    url: `staff/fetch-dashboard-home/${store.state.userId}`,
    loadingProperty: loading,
    showSuccessMessage: false,
  });

  if (!request) return;
  if (
    request.success &&
    request.message == "DASHBOARD_CONTENT_FETCHED_SUCCESSFULLY"
  ) {
    dateToday.value = request.date_today;
    const today = request.date_today.split("-");
    eventDays.value = request.days;
    calendarYear.value = +today[0];
    calendarMonth.value = +today[1];
    upcomingLectures.value = request.upcoming_lectures;
    notices.value = request.notices;
    assignedModules.value = request.assigned_intakes_modules;
    pendingResources.value = request.pending_resources;
    totalClassesToday.value = request.total_classes_today;
  }
};

onMounted(() => {
  fetchLecturerDashboardHome();
  checkIfBrowserIsSupported();
});

const onChangeCalendarMonth = async (diff: number) => {
  const date = new Date(
    +(calendarYear.value ?? 0),
    +(calendarMonth.value ?? 0) - 1,
    1
  );
  const newYearAndMonth = addMonths(date, diff);
  const newYear = newYearAndMonth.getFullYear();
  const newMonth = newYearAndMonth.getMonth() + 1;
  const isoMonth = newMonth <= 9 ? `0${newMonth}` : newMonth;
  newYearAndMonth.getMonth() + 1 <= 9
    ? "0" + (newYearAndMonth.getMonth() + 1)
    : newYearAndMonth.getMonth() + 1;

  const request = await useHttpRequest<{
    success: boolean;
    message: string;
    month_days: number[];
  }>({
    method: "GET",
    url: `staff/fetch-lecturer-monthly-events?month=${isoMonth}&year=${newYear}`,
    loadingProperty: isMonthCalendarLoading,
    showSuccessMessage: false,
  });

  if (!request) return;
  if (request.success && request.message == "DAYS_FETCHED_SUCCESSFULLY") {
    eventDays.value = request.month_days;
    calendarYear.value = +newYear;
    calendarMonth.value = +isoMonth;
  }
};

return { __sfc: true,loading, isMonthCalendarLoading, browserNotSupportedWarningDialogVisible, dateToday, calendarMonth, calendarYear, assignedModules, pendingResources, totalClassesToday, upcomingLectures, notices, eventDays, checkIfBrowserIsSupported, fetchLecturerDashboardHome, onChangeCalendarMonth, QuickStatisticsComponent, CalendarComponent, TodaysScheduleComponent, NoticeBoardDisplayComponent, DashboardItemsSummary, BrowserNotSupportedWarningDialog }
}

})